module.exports = __webpack_public_path__ + "img/housings.9dabed4b.png";